import { ExclamationCircle, Check2 } from 'react-bootstrap-icons';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
export const StatusCell = (rowProps) => {
    const { value, data, gridRef } = rowProps;
    if(value === 'waiting')
    {
        return <>To Be Uploaded</>
    }
    else if( value === 'pending')
    {
        return <></>
    }
    else if( value === 'error')
    {
        return <>
        <div  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <OverlayTrigger overlay={<Tooltip id="button-tooltip-2">{data.message}</Tooltip>}>
                <ExclamationCircle className="button-table" />
            </OverlayTrigger>
        </div>  
        </>
    }
    else if( value === "uploadComplete")
    {
        return <><Check2/></>
    }
    
  
}